export const BOOK_DEMO_URL = process.env.NEXT_PUBLIC_BOOK_DEMO_URL ?? "https://haulbase.ai/book-demo";

const preservedQueryPrefixes = ["utm_"];
const preservedQueryKeys = new Set(["gclid", "fbclid", "msclkid", "ref"]);

export function buildBookDemoHref(currentSearch: string, baseUrl = BOOK_DEMO_URL): string {
  const target = new URL(baseUrl);
  const source = new URLSearchParams(currentSearch.startsWith("?") ? currentSearch.slice(1) : currentSearch);

  for (const [key, value] of source.entries()) {
    if (shouldPreserveQueryParam(key)) {
      target.searchParams.set(key, value);
    }
  }

  return target.toString();
}

export function shouldPreserveQueryParam(key: string): boolean {
  const normalized = key.toLowerCase();
  return preservedQueryKeys.has(normalized) || preservedQueryPrefixes.some((prefix) => normalized.startsWith(prefix));
}
